<ng-progress
  #progressBar
  [trickleSpeed]="10"
  [speed]="10"
  [spinner]="false"
  color="#465dff"
></ng-progress>

<router-outlet />
